module.exports = __webpack_public_path__ + "static/media/challenge-photo.f9de7260.jpg";